// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__19AQq","footer":"ChangeClinic_footer__3Oq7E"};